import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "../css/paysuccess.css";

const CancelPay = () => {
  return (
    <div className="successDiv">
      <div className="success-container">
        <div className="modal-content">
          <div className="checkmark-circle payment-cancel-icon">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <h1>Payment cancelled</h1>
          <p>No payment was taken. Your items are still in your cart.</p>
          <Link className="payment-result-link" to="/checkout">
            Return to checkout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CancelPay;
